import CryptoJS from 'crypto-js';

interface Config {
  API_URL?: string;
  DOMAIN?: string;
  API_URL_DCC?: string;
  MY_CUSTOM_VAR?: string;
  ANOTHER_VAR?: string;
  [key: string]: any;
}

let config: Config = {};

export async function loadConfig(): Promise<Config> {
  try {
    const res = await fetch(`${process.env.PUBLIC_URL}/config.enc.json`, { cache: 'no-store' });
    const { iv, data } = await res.json();

    const key = CryptoJS.SHA256("my-strong-secret");
    const decrypted = CryptoJS.AES.decrypt(data, key, {
      iv: CryptoJS.enc.Base64.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const configText = decrypted.toString(CryptoJS.enc.Utf8);
    config = JSON.parse(configText);
    
    //console.log("✅ Config loaded successfully:", config);
    return config;
  } catch (error) {
   // console.error("❌ Failed to load encrypted config. Using .env fallback", error);
    // Fallback to environment variables
    config = {
      API_URL: process.env.REACT_APP_API_URL,
      DOMAIN: process.env.REACT_APP_DOMAIN,
      API_URL_DCC: process.env.REACT_APP_URL_DCC,
      MY_CUSTOM_VAR: process.env.REACT_APP_MY_CUSTOM_VAR,
      ANOTHER_VAR: process.env.REACT_APP_ANOTHER_VAR,
    };
    return config;
  }
}

export function getConfig(): Config {
  return config;
}

export function getConfigValue(key: string): string | undefined {
  return config[key];
}

// Initialize config on module load
loadConfig(); 